<div>
  <div vw class="enabled">
    <div vw-access-button class="active"></div>
    <div vw-plugin-wrapper>
      <div class="vw-plugin-top-wrapper"></div>
    </div>
  </div>

  <div class="accessibility-container">
    <div #accessibilityIcon class="accessibility-icon" (click)="toggleAccessibility()">
      <img src="../../../assets/transparencia-images/icon-acessibilidade-2025.png" class="icon-acessibilidade-2025">
    </div>

    <div #accessibilityMenu class="accessibility-menu">
      <button id="font-increase" class="accessibility-button" title="Aumentar Fonte" (click)="aumentarTexto()"
        ngbTooltip="Aumentar Fonte">A+</button>
      <button id="font-decrease" class="accessibility-button" title="Diminuir Fonte" (click)="diminuirTexto()"
        ngbTooltip="Diminuir Fonte">A-</button>
      <button id="restore-default" class="accessibility-button" title="Restaurar Fonte" (click)="restaurarPadrao()"
        ngbTooltip="Restaurar Fonte"><i class="fa-solid fa-arrow-rotate-left"></i>
        Fonte Padrão</button>
      <button id="darkTheme" class="accessibility-button" title="{{ darkColor ? 'Modo claro' : 'Modo escuro' }}"
        (click)="modetoggle()">
        <i class="fa-solid fa-circle-half-stroke"></i> {{ darkColor ? 'Modo Claro' : 'Modo Escuro' }}
      </button>
    </div>
  </div>

  <button *ngIf="showBotaoTopo" class="btn-voltar-topo" (click)="voltarAoTopo()">
    <i class="fas fa-arrow-up" style="color:#fff; font-size: 15px;"></i>
  </button>

  <div class="selector-color-options mb-3">
    <a id="grey" class="selector-color-grey" (click)="grey()"
      ngbTooltip="Visualizar o sistema na cor cinza. Para ativar a cor no seu portal, entre em contato."></a>
    <a id="blue" class="selector-color-blue" (click)="blue()"
      ngbTooltip="Visualizar o sistema na cor azul. Para ativar a cor no seu portal, entre em contato."></a>
    <a id="green" class="selector-color-green" (click)="green()"
      ngbTooltip="Visualizar o sistema na cor verde. Para ativar a cor no seu portal, entre em contato."></a>
    <a id="red" class="selector-color-red" (click)="red()"
      ngbTooltip="Visualizar o sistema na cor vermelha. Para ativar a cor no seu portal, entre em contato."></a>
    <a id="yellow" class="selector-color-yellow" (click)="yellow()"
      ngbTooltip="Visualizar o sistema na cor amarela. Para ativar a cor no seu portal, entre em contato."></a>
    <a id="pink" class="selector-color-pink" (click)="pink()"
      ngbTooltip="Visualizar o sistema na cor rosa. Para ativar a cor no seu portal, entre em contato."></a>
  </div>
</div>